;(function () {
  angular
    .module('contrast.org-stats')
    .controller('OrgStatsAppsCtrl', OrgStatsAppsCtrl)

  function OrgStatsAppsCtrl(
    $scope,
    $window,
    $location,
    $translate,
    OrgStatsService,
    PromiseService,
    ErrorService,
    LoadFilterRouteService,
    UserService,
    ApplicationFactory,
    LicenseFactory,
    ORG_STATS_CONSTANTS,
    QUICK_FILTERS
  ) {
    'ngInject'

    var vm = this
    var quickFiltersPromise

    var translGlobal = {
      title_all_applications: $translate.instant('title_all_applications'),
      title_applicationsReports_recentlyAddedApps: $translate.instant(
        'title_applicationsReports_recentlyAddedApps'
      ),
      title_applicationsReports_notSeenApps: $translate.instant(
        'title_applicationsReports_notSeenApps'
      ),
      title_applicationsNearingExpiration: $translate.instant(
        'title_applicationsNearingExpiration'
      )
    }

    angular.extend(vm, {
      apps: {
        breakdowns: ORG_STATS_CONSTANTS.APP_BREAKDOWN_SELECT,
        breakdown: ORG_STATS_CONSTANTS.APP_BREAKDOWN_SELECT[0].keycode,
        data: {},
        donutConfig: {},
        showMoreLimit: 5,
        drilldown: [],
        thermometerConfig: {}
      },
      filters: {
        quickFilters: [],
        selectedQuickFilter: {
          name: translGlobal.title_all_applications,
          filterType: 'ALL',
          count: '?'
        }
      },
      loading: {
        stats: true,
        breakdown: true,
        licenses: true
      },
      donutSelection: undefined,
      recentlyAddedAppsTitle:
        translGlobal.title_applicationsReports_recentlyAddedApps,
      notSeenAppsTitle: translGlobal.title_applicationsReports_notSeenApps,
      model: {
        assessment: {
          apps: []
        }
      }
    })

    angular.extend(vm, {
      onAppBreakdownChange: onAppBreakdownChange,
      onQuickFilterSelect: onQuickFilterSelect,
      onDonutItemClick: onDonutItemClick,
      hasApps: hasApps,
      isLanguageSelected: isLanguageSelected,
      onAllAppsClick: onApplicationAllClick,
      onAppsClick: onAppsClick,
      onApplicationLanguageClick: onApplicationLanguageClick,
      onHighRiskClick: onHighRiskClick,
      showMore: showMore,
      showAllAppsNearingExpiration: showAllAppsNearingExpiration,
      getSnapshotClassHighRisk: getSnapshotClassHighRisk,
      getSnapshotClassExpirations: getSnapshotClassExpirations,
      getSnapshotClassProtectionCoverage: getSnapshotClassProtectionCoverage
    })

    function init() {
      _getAppStats()
      _getAppStatsDrilldown()
      _getQuickFilters()
      _getLicenseStats()
      _registerClickHandler()
      _loadUpcomingAssessmentExpiredLicenses()
    }

    function onAppBreakdownChange() {
      vm.loading.breakdown = true
      _getDonutBreakdown()
    }

    function onQuickFilterSelect(filter) {
      vm.filters.selectedQuickFilter = filter
      _getAppStats()
      _getAppStatsDrilldown()
    }

    function onDonutItemClick(item) {
      if (
        angular.isDefined(vm.donutSelection) &&
        vm.donutSelection.group === item.group &&
        vm.donutSelection.name === item.name
      ) {
        vm.donutSelection = undefined
      } else {
        vm.donutSelection = item
      }
      _getDonutBreakdown(true)
    }

    function hasApps() {
      return vm.apps.thermometerConfig.count !== 0
    }

    function isLanguageSelected() {
      return (
        angular.isDefined(vm.donutSelection) &&
        vm.donutSelection.group === ORG_STATS_CONSTANTS.APP_BREAKDOWNS.LANGUAGES
      )
    }

    function onApplicationAllClick() {
      LoadFilterRouteService.goToApps(vm.filters.selectedQuickFilter.filterType)
    }

    function onAppsClick() {
      LoadFilterRouteService.goToApps(vm.filters.selectedQuickFilter.filterType)
    }

    function onApplicationLanguageClick() {
      LoadFilterRouteService.goToApps(
        vm.filters.selectedQuickFilter.filterType,
        vm.donutSelection.name
      )
    }

    function onHighRiskClick() {
      LoadFilterRouteService.goToApps(QUICK_FILTERS.APPS.HIGH_RISK.KEY)
    }

    function showMore(apps, title) {
      OrgStatsService.openShowMoreModal(apps, title, _goToAppOverview)
    }

    function _goToAppOverview(app) {
      $location.path(UserService.buildUrl(/applications/ + app.app_id))
    }

    function _getAppStatsDrilldown() {
      vm.loading.breakdown = true
      vm.loading.breakdownPromise = OrgStatsService.getAppStatsDrilldown(
        vm.filters.selectedQuickFilter.filterType
      )
        .then(function (applications) {
          vm.apps.drilldown = applications
          vm.donutSelection = undefined
          _getDonutBreakdown()
        })
        .finally(function () {
          vm.loading.breakdown = false
        })
    }

    function _getAppStats() {
      vm.loading.stats = true
      vm.loading.statsPromise = OrgStatsService.getAppStatsBreakdown(
        [
          ORG_STATS_CONSTANTS.APP_BREAKDOWNS.RECENT,
          ORG_STATS_CONSTANTS.APP_BREAKDOWNS.UNSEEN
        ],
        vm.filters.selectedQuickFilter.filterType
      )
        .then(function (stats) {
          vm.apps.data = stats.data
          vm.apps.thermometerConfig = stats.thermometerConfig
        })
        .finally(function () {
          vm.loading.stats = false
        })
    }

    function _getDonutBreakdown(update) {
      vm.apps.donutConfig = OrgStatsService.buildAppDonutBreakdown(
        vm.apps.drilldown,
        [vm.apps.breakdown, ORG_STATS_CONSTANTS.APP_BREAKDOWNS.LANGUAGES],
        vm.donutSelection
      )
      if (update) {
        $scope.$digest()
      }
    }

    function _getQuickFilters() {
      if (quickFiltersPromise) {
        PromiseService.cancelPromise(quickFiltersPromise)
      }

      var filters = {
        includeArchived: true
      }

      quickFiltersPromise =
        ApplicationFactory.getApplicationsQuickFilters(filters)

      quickFiltersPromise
        .then(function (response) {
          vm.filters.quickFilters = response.data.filters

          vm.filters.selectedQuickFilter = vm.filters.quickFilters.find(
            function (filter) {
              return (
                filter.filterType === vm.filters.selectedQuickFilter.filterType
              )
            }
          )
        })
        .catch(ErrorService.processError)

      return quickFiltersPromise
    }

    function _getLicenseStats() {
      vm.loading.licenses = true
      vm.loading.licensesPromise = OrgStatsService.getLicenseStats()
        .then(function (stats) {
          vm.licenses = stats.data.totalAssessment - stats.data.assessment
        })
        .finally(function () {
          vm.loading.licenses = false
        })
    }

    function _registerClickHandler() {
      angular.element($window).on('click', _onClick)
      $scope.$on('$destroy', _onDestroy)
    }

    function _onClick() {
      if (angular.isDefined(vm.donutSelection)) {
        vm.donutSelection = undefined
        _getDonutBreakdown(true)
      }
    }

    function _onDestroy() {
      angular.element($window).off('click', _onClick)
    }

    function _loadUpcomingAssessmentExpiredLicenses() {
      LicenseFactory.getUpcomingAssessmentExpiredLicenses()
        .then(function (response) {
          vm.model.assessment.apps = response.data.applications
        })
        .catch(ErrorService.processError)
    }

    function showAllAppsNearingExpiration() {
      OrgStatsService.openShowMoreModal(
        vm.model.assessment.apps,
        translGlobal.title_applicationsNearingExpiration,
        _goToAppOverview
      )
    }

    function getSnapshotClassHighRisk() {
      return _getSnapshotClass(vm.apps.data.critical)
    }

    function getSnapshotClassExpirations() {
      return _getSnapshotClass(vm.apps.data.expiring)
    }

    function getSnapshotClassProtectionCoverage() {
      var val = vm.apps.data.protectedPercent
      var str = 'data-circle-'
      if (val >= 50 && val <= 100) {
        str += 'red'
      } else if (val >= 26 && val <= 49) {
        str += 'orange'
      } else if (val >= 10 && val <= 25) {
        str += 'yellow'
      } else {
        str += 'green'
      }
      return str
    }

    function _getSnapshotClass(val) {
      var str = 'data-circle-'
      if (val === 0) {
        str += 'green'
      } else if (val === 1) {
        str += 'yellow-green'
      } else if (val === 2) {
        str += 'yellow'
      } else if (val === 3) {
        str += 'orange'
      } else {
        str += 'red'
      }
      return str
    }

    init()
  }
})()
